import React from "react";
import "./App.css"; // import the CSS file
import { FaTruck, FaUndo, FaStar } from "react-icons/fa";
import bag1 from "./assets/bag1.jpg";
import bag2 from "./assets/bag2.jpg";
import bag3 from "./assets/bag3.jpg";
import bag4 from "./assets/bag4.jpg";

function App() {
  return (
  
  <div className="container">
      {/* Navbar */}
      <header className="navbar">
        <h1 className="logo">BackPack NG</h1>
        <nav className="nav-links">
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#testimonials">Testimonials</a>
          <a href="#blogs">Blogs</a>
          <a href="#offers">Offers</a>
        </nav>
        <button className="btn">Shop Now</button>
      </header>

     {/* Hero Section */}
<section id="home" className="hero">
  <div className="hero-overlay">
    <div className="hero-text">
      <h2>Move Fast. <br /> Pack Smarter.</h2>
      <p>
        Crafted for explorers and city movers alike, our bags balance sleek 
        design with rugged durability because style shouldn’t stop when 
        the journey starts.
      </p>
      <button className="btn">Find Your Fit →</button>
    </div>
  </div>
</section>


      {/* What We Offer */}
<section className="offers">
  <h1>What we offer?</h1><br></br>
  <div className="offer-cards">
    <div className="card">
      <FaTruck className="card-icon" />
      <h3>Free Shipping</h3><br></br>
      <p>Get your backpack delivered with zero shipping cost.</p>
    </div>
    <div className="card">
      <FaUndo className="card-icon" />
      <h3>Easy Return Policy</h3><br></br>
      <p>Any product is returnable within 7 days without hassle.</p>
    </div>
    <div className="card">
      <FaStar className="card-icon" />
      <h3>Premium Quality</h3><br></br>
      <p>Made with high quality fabrics for durability and comfort.</p>
    </div>
  </div>
</section>



      {/* About Us */}
      <section id="about" className="about">
        <h1>About Us</h1><br></br>
        <p>
          We specialize in creating minimalistic, durable, and functional
          backpacks for everyday use. With thousands of happy users worldwide,
          we continue to redefine comfort and style in travel gear.
        </p><br></br>
        <button className="btn">Click To Buy Now</button>
      </section>

      {/* Best Deals */}
      <section className="deals">
        <h3>Best deals for us</h3>
        <div className="deal-products">
          <div className="product">
          <img src={bag1} alt="Backpack" />
            <h4>Walmart Academia Backpack</h4>
            <button className="btn">Shop Now</button>
          </div>
          <div className="product">
          <img src={bag2} alt="Backpack" />
            <h4>Canyon Anti-theft Backpack</h4>
            <button className="btn">Shop Now</button>
          </div>
          <div className="product">
          <img src={bag3} alt="Backpack" />
            <h4>Explorer Hiking Backpack</h4>
            <button className="btn">Shop Now</button>
          </div>
          <div className="product">
          <img src={bag4} alt="Backpack" />
            <h4>Urban Slim Laptop Backpack</h4>
            <button className="btn">Shop Now</button>
          </div>
        </div>

      </section>

      {/* Testimonials */}
      <section id="testimonials" className="testimonials">
        <h1>Testimonials</h1><br></br>
        <div className="testimonial-cards">
          <div className="t-card">
            <p>“This backpack is the best investment for my travels!”</p><br></br>
            <h4>David Santos</h4><br></br>
            <span>Business Manager</span>
          </div>
          <div className="t-card">
            <p>“Stylish, durable and lightweight. Highly recommend!”</p><br></br>
            <h4>Mark Sli</h4><br></br>
            <span>CEO, Pk Homme</span>
          </div>
          <div className="t-card">
            <p>“Perfect for work and travel, fits everything I need.”</p><br></br>
            <h4>Mas Roy</h4><br></br>
            <span>Business Developer</span>
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="newsletter">
        <h1>FOR SPECIAL OFFERS JOIN US</h1><br></br>
        <p>Sign up for the newsletter and receive a discount off your first order.</p>
        <div className="newsletter-form">
          <input type="email" placeholder="Enter your email" />
          <button className="btn">Sign Up</button>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-top">
          <div>
            <h4>Backpack NG</h4>
            <p>Men at the key lesson no hold in let much do made took held help.</p>
            <div className="socials">
              <a href="#">Facebook</a>
              <a href="#">Twitter</a>
              <a href="#">LinkedIn</a>
            </div>
          </div>
          <div className="footer-links">
            <div>
              <h5>Features</h5>
              <ul>
                <li>Pricing</li>
                <li>Login</li>
                <li>Signup</li>
              </ul>
            </div>
            <div>
              <h5>Legal</h5>
              <ul>
                <li>Privacy Policy</li>
                <li>Terms of Use</li>
                <li>Legal Notice</li>
              </ul>
            </div>
          </div>
        </div>
        <p className="copyright">©backpackng.com</p>
      </footer>
    </div>
  );
}

export default App;
